/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { FC } from "react"
import { useSelector } from "react-redux"
import { getCompanyName } from "../../../../reducers/companyInfo"
import { HR, Spacer } from "../../atoms/Atoms"
import { Container, H3 } from "@carrotfertility/carotene"
import { PiiText } from "services/tracking"
import { Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"

export type YourCostShareInformationalProps = {
  reimbursementPercent: number
  isDefaultCategory: boolean
  costShareOnly: boolean
  supportsOOPM: boolean
}

const YourCostShareInformational: FC<YourCostShareInformationalProps> = ({
  reimbursementPercent,
  isDefaultCategory,
  costShareOnly,
  supportsOOPM
}) => {
  const companyName = useSelector(getCompanyName)

  return (
    <>
      {!costShareOnly && (
        <>
          <Container paddingTopBottom="large">
            <HR color={"black-10"} />
          </Container>
          <H3>
            <FormattedMessage
              defaultMessage="Your cost share with {companyName}"
              values={{
                companyName: <PiiText>{companyName}</PiiText>
              }}
            />
          </H3>
        </>
      )}
      {!supportsOOPM && (
        <Typography>
          {isDefaultCategory ? (
            <FormattedMessage
              defaultMessage="Cost sharing is when your employer pays for a percentage of your medical expenses. {companyName} will cover {reimbursementPercent, number, ::percent} of each approved eligible expense."
              values={{
                companyName: <PiiText>{companyName}</PiiText>,
                reimbursementPercent: reimbursementPercent / 100
              }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="Cost sharing is when your employer pays for a percentage of your medical expenses. {companyName} will cover {reimbursementPercent, number, ::percent} of each approved eligible expense in this category."
              values={{
                companyName: <PiiText>{companyName}</PiiText>,
                reimbursementPercent: reimbursementPercent / 100
              }}
            />
          )}
          {costShareOnly && (
            <>
              <Spacer height={1} />
              <FormattedMessage defaultMessage="Carrot funds you use may also be subject to bank fees, taxes, and other plan details." />
            </>
          )}
        </Typography>
      )}
      {supportsOOPM && (
        <Typography>
          <FormattedMessage defaultMessage="Cost sharing is when your employer pays for a percentage of your eligible expenses with Carrot." />
          <Spacer height={0.5} />
          <FormattedMessage
            defaultMessage="After you meet your deductible but before you meet your health plan's out-of-pocket maximum, {companyName} will cover {reimbursementPercent,number, ::percent} of your approved eligible expenses."
            values={{
              companyName: <PiiText>{companyName}</PiiText>,
              reimbursementPercent: reimbursementPercent / 100
            }}
          />
          <Spacer height={0.5} />
          <FormattedMessage
            defaultMessage="After you meet your out-of-pocket maximum, {companyName} will cover 100%."
            values={{
              companyName: <PiiText>{companyName}</PiiText>
            }}
          />
          {costShareOnly && (
            <>
              <Spacer height={1} />
              <FormattedMessage defaultMessage="Carrot funds you use may also be subject to bank fees, taxes, and other plan details." />
            </>
          )}
        </Typography>
      )}
    </>
  )
}

export { YourCostShareInformational }
